export default {
  actions: {

  },
  mutations: {
    updateStatisticPercent(state, { status, isDelOrAdd } = {}) {
      if (!status) return;
      if (isDelOrAdd) {
        state.statistic.total--;
        state.statistic.details[status].amount--;
      } else {
        state.statistic.total++;
        state.statistic.details[status].amount++;
      }
      let { total, details } = state.statistic;
      for (let i in details) {
        details[i].percent = total
          ? ((details[i].amount * 100) / total).toFixed(2)
          : 0;
      }
    },
    updateStatisticNumber(state, { prev, next } = {}) {
      if (!prev || !next) return;
      state.statistic.details[prev].amount--;
      state.statistic.details[prev].percent = (
        (state.statistic.details[prev].amount * 100) /
        state.statistic.total
      ).toFixed(2);
      state.statistic.details[next].amount++;
      state.statistic.details[next].percent = (
        (state.statistic.details[next].amount * 100) /
        state.statistic.total
      ).toFixed(2);
    },
    setStatistic(state, { vals, statusList }) {
      let total = Object.values(vals).reduce((sum, i) => sum + i);
      let details = {};
      for (var itm of statusList) {
        details[itm.name] = {
          amount: vals[itm.name],
          percent: total ? ((vals[itm.name] * 100) / total).toFixed(2) : 0,
          color: itm.color,
        };
      }
      state.statistic = { total, details };
    },
  },
  state: {
    statistic: { total: 0, details: {} }
  },
  getters: {
    Statistic(state) {
      return state.statistic
    },
  }
}